<template>
  <div class="text-center">
    <edit-company-model
      method="put"
      :is-active.sync="isEditting"
      :company="company"
      @edited="companyEdited"
    />

    <v-menu
      v-model="menu"
      :nudge-width="200"
      offset-x
      :close-on-content-click="false"
      :close-on-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="primary" v-on="on">
          <v-icon>mdi-account-edit-outline</v-icon>
          Account
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon size="40">mdi-shield-account-outline</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ company.name }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="menu = false">
                <v-icon size="40">mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-list v-if="!!company.has_owner_consent">
          <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :loading="isActivating"
                :input-value="!!company.is_active"
                @change="toggleActivity"
                :disabled="(isActivating || company.is_rejected == true)"
                color="primary"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title>Activate {{ company.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list v-if="company.has_owner_consent">
          <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :input-value="!!company.is_verified"
                @change="verifyCompany"
                color="primary"
                :disabled="(company.is_verified == true || company.is_rejected == true)"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title
              ><span v-if="company.is_verified == false">Manually Verify</span
              ><span v-else>Verified</span></v-list-item-title
            >
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :loading="isRejecting"
                :input-value="company.is_rejected"
                @change="rejectCompany"
                color="primary"
                :disabled="company.is_verified == true || company.is_active == true"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title
              ><span v-if="company.is_rejected == false">Is Rejected</span
              ><span v-else>Rejected</span></v-list-item-title
            >
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <!-- <v-spacer></v-spacer> -->
          <v-btn text @click="isEditting = true" v-if="!company.is_archived">
            <v-icon color="light-blue lighten-4">
              mdi-account-edit-outline
            </v-icon>
            Edit
          </v-btn>
          <v-btn text @click="destroy(true)">
            <v-icon color="light-blue lighten-4">mdi-delete-circle-outline</v-icon>
            Delete
          </v-btn>
          <v-btn text @click="destroy(false)" v-if="!company.is_archived">
            <v-icon color="light-blue lighten-4">mdi-archive</v-icon>
            Archive
          </v-btn>
          <v-btn text @click="restore" :loading="isRestoring" v-if="company.is_archived">
            <v-icon color="light-blue lighten-4">mdi-restore</v-icon>
            Restore
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
// import get from "lodash/get";
// import { getcompanyType } from "./utils";

import EditCompanyModel from "./form";

export default {
  components: { EditCompanyModel },
  props: { company: { required: true, type: Object } },
  data: () => ({
    menu: false,
    isEditting: false,
    isActivating: false,
    isVerifying: false,
    isRejecting: false,
    isRestoring: false,
  }),
  computed: {
    // companyType() {
    //   return getcompanyType(this.company);
    // },
    // canModify() {
    //   return get(this.$globalStore.company, "id") !== get(this.company, "id");
    // },
  },
  methods: {
    toggleActivity() {
      this.isActivating = true;
      const { id } = this.company;
      this.$http
        .put(`api/v1/companies/${id}/activity`)
        .then((company) => {
          this.$emit("update:company", Object.assign({}, this.company, company));
          Notify.success("Operation successful");
        })
        .catch(this.showResponseError)
        .finally(() => (this.isActivating = false));
    },

    async verifyCompany() {
      const { id } = this.company;
      this.isVerifying = true;
      await this.$http
        .post(`api/v1/companies/${id}/verification`)
        .then(({ company }) => {
          this.$emit("update:company", company);
          Notify.success("Operation was successfull");
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
          //   this.menu = true;
          this.$emit("update:company");
        })
        .finally(() => (this.isVerifying = false));
    },

    async rejectCompany(val) {
      this.isRejecting = true;
      const action = val === true ? "reject" : "accept";
      this.$http
        .post(`api/v1/companies/onboarding/${this.company.id}/${action}`, { type: "company" })
        .finally(() => {
          this.isRejecting = false;
          this.$emit("update:company", this.company);
        });
    },

    companyEdited({ company }) {
      this.isEditting = false;
      this.menu = false;
      this.$emit("update:company", company);
      Notify.success("company was updated successfully");
    },
    restore() {
      this.isRestoring = true;
      this.$http
        .post(`api/v1/companys/restore/${this.company.id}`)
        .then(({ message }) => {
          this.isRestoring = false;
          Notify.success(message);
          this.$router.push({ name: "companies" });
        })
        .catch((error) => {
          this.isRestoring = false;
          this.menu = false;
          Notify.errorFromResponse(error, { close: true });
        });
    },
    destroy(permanent) {
      const params = {};
      if (permanent) {
        params.delete = true;
      }
      const title = permanent ? "This action is irreversible" : "The company will be archived";
      Notify.confirm(`${title}, All the company data will be lost`).then(() => {
        this.$http.delete(`/api/v1/companies/${this.company.id}`, { params }).then(() => {
          Notify.success("company Was deleted successfully!");
          this.$router.push({ name: "companys" });
        });
      });
    },
  },
};
</script>
